<template>
  <date-time-input
    v-model="selectedValue"
    :label="label"
    :html-id="fieldId"
    :type="inputFormat"
    :min="min"
    :max="max"
    :name="name"
    :wrapper-class="containerClass"
    locale="en-gb"
    :required="required"
    :disabled="disabled"
  />
  <input
    v-if="hiddenInputName"
    type="hidden"
    :name="hiddenInputName"
    :value="formattedValue"
  >
</template>

<script>
import { ref, computed, watchEffect } from "vue";
import { useFeatherDayJs } from "@raptor/feather-ui";

export default {
  name: "DatePicker",
  props: {
    label:{
      type: String,
      default: ""
    },
    isCurrentDateTime:{
      type: String,
      default: ""
    },
    inputType:{
      type: String,
      default: ""
    },
    containerClass:{
      type: String,
      default: ""
    },
    isRequired:{
      type: String,
      default: "false"
    },
    isDisabled:{
      type: String,
      default: "false"
    },
    fieldId:{
      type: String,
      default: ""
    },
    name:{
      type: String,
      default: ""
    },
    min:{
      type: [Date, String],
      default: null
    },
    max:{
      type: [Date, String],
      default: null
    },
    savedDate:{
      type: String,
      default: ""
    },
    hiddenInputName:{
      type: String,
      default: ""
    }
  },

  setup(props){
    const selectedValue = ref(null);
    const { dayjs } = useFeatherDayJs();

    const formatDate = (date) => {
      return dayjs.value(date).format("YYYY-MM-DD");
    };

    const formatDateTime = (date) => {
      return dayjs.value(date).format("YYYY-MM-DD HH:mm");
    };

    watchEffect(() => {
      if (props.savedDate?.trim()) {
        const parsed = new Date(props.savedDate);
        if (!isNaN(parsed.getTime())) {
          selectedValue.value = parsed;
          return;
        }
      }
      if (props.isCurrentDateTime === "true") {
        selectedValue.value = new Date();
        return;
      }
      selectedValue.value = null;
    });

    const formattedValue = computed(() => {
      if (selectedValue.value === null) return "";
      return props.inputType === "date"
        ? formatDate(selectedValue.value)
        : formatDateTime(selectedValue.value);
    });

    const inputFormat = computed(() => {
      return props.inputType === "date-time" ? "date-time" : "date";
    });

    const required = computed(() => {
      return props.isRequired === "true";
    });

    const disabled = computed(() => {
      return props.isDisabled === "true";
    });

    return { selectedValue, formattedValue, inputFormat, required, disabled };
  }
};
</script>
